import { VueModule } from '@Foundation/utilities';
import SpotscanEmbed from './code/Scripts/components/spotscan-embed.vue';

export default VueModule({
    components: {
        SpotscanEmbed
    }
});